// 9fbef606107a605d69c0edbcd8029e5d
export const BRAND_CONFIG = {
  TCP: 'childrensplace.com',
  GYM: 'gymboree.com',
  SNJ: 'sugarandjade.com',
  PJP: 'pjplace.com',
};

const canonicalUrlsConfig = (context) => {
  const { brand, path, withCountry } = context;
  let asPath = '';
  const totalPathCa = path?.split('/ca/');
  const totalPathUs = path?.split('/us/');

  if (totalPathUs.length > 1) {
    asPath = totalPathUs[totalPathUs.length - 1];
  }

  if (totalPathCa.length > 1) {
    asPath = totalPathCa?.[totalPathCa.length - 1];
  }
  if (path.indexOf('content/') > -1) {
    asPath = path;
  }

  if (brand?.toLowerCase() !== 'pjp' && brand?.toLowerCase() !== 'snj') {
    return [
      {
        id: 'en-us',
        canonicalUrl: `https://www.${BRAND_CONFIG[brand]}${!withCountry ? '/us/' : ''}${asPath}`,
      },
      {
        id: 'es-us',
        canonicalUrl: `https://es.${BRAND_CONFIG[brand]}${!withCountry ? '/us/' : ''}${asPath}`,
      },
      {
        id: 'en-ca',
        canonicalUrl: `https://www.${BRAND_CONFIG[brand]}${!withCountry ? '/ca/' : ''}${asPath}`,
      },
      {
        id: 'fr-ca',
        canonicalUrl: `https://fr.${BRAND_CONFIG[brand]}${!withCountry ? '/ca/' : ''}${asPath}`,
      },
    ];
  }
  return [
    {
      id: 'en-us',
      canonicalUrl: `https://www.${BRAND_CONFIG[brand]}${!withCountry ? '/us/' : ''}${asPath}`,
    },
  ];
};

export default canonicalUrlsConfig;
